module.exports = __webpack_public_path__ + "static/media/landing-subjects.93493192.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/landing-subjects.png
// module id = 578
// module chunks = 0